export enum MuiSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
